import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SmartintegService } from '../../../services/smartinteg.service';
import { ProvedorEndpoint } from '../../../types/smartinteg';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-seletor-endpoint',
  templateUrl: './seletor-endpoint.component.html',
  styleUrl: './seletor-endpoint.component.css'
})
export class SeletorEndpointComponent implements OnInit {

  @Input() conexaoId: string = '';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = 'Selecione um endpoint';
  @Input() label: string = 'Endpoint';
  @Input() endpointSelecionadoId?: string;

  @Output() endpointSelecionado = new EventEmitter<ProvedorEndpoint>();

  endpoints: ProvedorEndpoint[] = [];
  endpointAtual?: ProvedorEndpoint;
  loading: boolean = false;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    if (this.conexaoId) {
      this.carregarEndpoints();
    }
  }

  ngOnChanges(): void {
    if (this.conexaoId) {
      this.carregarEndpoints();
    }
  }

  carregarEndpoints(): void {
    this.loading = true;
    this.smartintegService.listarEndpointsPorConexao(this.conexaoId).subscribe({
      next: (endpoints) => {
        this.endpoints = endpoints;

        // Se há um endpoint pré-selecionado, encontrar e emitir
        if (this.endpointSelecionadoId) {
          const endpointPreSelecionado = endpoints.find(e => e.id === this.endpointSelecionadoId);
          if (endpointPreSelecionado) {
            this.endpointAtual = endpointPreSelecionado;
            this.endpointSelecionado.emit(endpointPreSelecionado);
          }
        }

        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar endpoints: ' + error.error?.message);
        this.loading = false;
      }
    });
  }

  onEndpointChange(event: any): void {
    const endpoint = this.endpoints.find(e => e.id === event.value);
    if (endpoint) {
      this.endpointSelecionado.emit(endpoint);
    }
  }

  getMetodoSeverity(metodo: string): string {
    switch (metodo) {
      case 'GET': return 'info';
      case 'POST': return 'success';
      case 'PUT': return 'warning';
      case 'DELETE': return 'danger';
      default: return 'secondary';
    }
  }
}
